<template>
  <!-- <v-layout row>
    <v-flex xs12 sm12> -->
      <v-card height="100%">
        <v-card-title primary class="primary--text">
          <h3 color="primary">DUE INVOICES</h3>
        </v-card-title>
        <v-list one-line>
          <!-- <v-list-tile>
            <v-btn class="primary white--text" @click="openClosedTransactions">
              View Statemtents
            </v-btn>
          </v-list-tile> -->
          <v-divider />
          <template v-for="(item, index) in invoiceList">
            <!-- <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader> -->
            <v-list-tile :key="index" avatar class="due-inv-list" >
              <v-list-tile-avatar>
                <!-- <img :src="item.avatar"> -->
                <i class="material-icons">
                  <b>&#8377;</b>
                </i>
              </v-list-tile-avatar>
                <!-- <v-spacer v-if="!item.isCredited"/> -->
                <v-list-tile-content>
                  <!-- <v-list-tile-title> -->
                    <!-- <v-list-tile-title><v-chip :color="(!item.isCredited?'red':'blue')" text-color="white">{{item.totalAmount}}</v-chip></v-list-tile-title> -->

                    <v-list-tile-title v-if = !item.isCredited>
                      <h3> 
                        <b class="red--text font-weight-bold"> 
                          <!-- {{(((item.totalAmount + (item.labourAmount || 0 | amount)) - (item.discountAmount || 0 | amount)) - (item.paidAmount || 0 | amount)) || 0 | amount }} </b> -->
                          <!-- {{((Number.parseFloat(item.totalAmount + Number.parseFloat(item.labourAmount || 0 | amount)) - Number.parseFloat(item.discountAmount || 0 | amount)) - Number.parseFloat(item.paidAmount || 0 | amount)) || 0 | amount }} </b> -->
                          {{ Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | amount) - Number.parseFloat(item.paidAmount || 0 | amount)) || 0 | amount }}
                        </b>
                        <b class="Font-weight-light">
                          <!-- ( {{ (item.totalAmount + item.labourAmount - item.discountAmount) || 0 | amount }} ~ {{item.paidAmount || 0 | amount }})  -->
                          <!-- ( {{ ((Number.parseFloat(item.totalAmount + Number.parseFloat(item.labourAmount || 0 | amount)) - Number.parseFloat(item.discountAmount || 0 | amount)) ) || 0 | amount }} ~ {{item.paidAmount || 0 | amount }}  ) -->
                          ({{ Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | amount)) || 0 | amount }} ~ {{Number.parseFloat(Number.parseFloat(item.paidAmount || 0 | amount)) || 0 | amount}})
                        </b>
                      </h3>
                    </v-list-tile-title>

                    <v-list-tile-title v-if = item.isCredited>
                      <h3> 
                        <b class="red--text font-weight-bold"> 
                          <!-- {{((Number.parseFloat(item.totalAmount + Number.parseFloat(item.labourAmount || 0 | amount)) - Number.parseFloat(item.discountAmount || 0 | amount)) - Number.parseFloat(item.paidAmount || 0 | amount)) || 0 | amount }} </b> -->
                          <!-- {{(item.totalAmount + item.labourAmount - item.discountAmount) - item.paidAmount || 0 | amount }} </b> -->
                          {{ Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | amount) - Number.parseFloat(item.paidAmount || 0 | amount)) || 0 | amount }}
                        </b>
                        <b class="Font-weight-light">  
                          <!-- ( {{(item.totalAmount + item.labourAmount - item.discountAmount) || 0 | amount }} :- {{item.paidAmount || 0 | amount }}) -->
                          <!-- ( {{ ((Number.parseFloat(item.totalAmount + Number.parseFloat(item.labourAmount || 0 | amount)) - Number.parseFloat(item.discountAmount || 0 | amount)) ) || 0 | amount }} ~ {{item.paidAmount || 0 | amount }}  ) -->
                          <!-- ({{ Number.parseFloat(item.totalAmount || 0 | amount) }} ~ {{Number.parseFloat(item.paidAmount || 0 | amount)}}) -->
                          ({{ Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | amount)) || 0 | amount }} ~ {{Number.parseFloat(Number.parseFloat(item.paidAmount || 0 | amount)) || 0 | amount}})
                        </b>
                      </h3>
                    </v-list-tile-title>
                    
                    <v-list-tile-sub-title>
                      <h4 class="primary--text font-weight-light"> {{item['date']}} </h4>
                    </v-list-tile-sub-title>
                  <!-- </v-list-tile-title> -->
                </v-list-tile-content>
                
                <v-list-tile-action>
                  <v-data-table
                    :items="invoiceList"
                    hide-actions
                    row
                    wrap
                    class="elevation">  
                    <!-- <template slot="items" slot-scope="props">
                      <td>
                        <v-btn large class="primary white--text" @click.stop="openInvoice(props.item['.key'])">
                          <v-icon>local_parking</v-icon>
                        </v-btn>
                      </td>
                    </template>    
                    <template slot="no-data">
                      No Items
                    </template> -->
                  </v-data-table>
                    <v-dialog
                      v-model="dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                      scrollable
                    >
                    <v-card tile>
                      <v-toolbar card dark color="primary">
                        <v-toolbar-title>Invoice Detail</v-toolbar-title>
                        <v-spacer/>
                        <v-btn icon dark @click.native="dialog = false">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-toolbar>
                
                      <invoice-payment :isBuyer="isBuyer" :selectedInvoiceId="selectedInvoiceId" @close="dialog = false" @updateInvoice="updateInvoice"/>
                        <div style="flex: 1 1 auto;"></div>
                    </v-card>
                  </v-dialog>
                </v-list-tile-action>
            </v-list-tile>
        <v-divider :key="index+'divider'"/>
      </template>
    </v-list>
  </v-card>
    <!-- </v-flex>
  </v-layout> -->
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import InvoicePayment from '../InvoicePayment/'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']

export default {
  components: {
    InvoicePayment
  },
  props: {
     isBuyer: {
         type: Boolean
     },
     invoices : {
         type: Array
     }
  },
  data () {
    return {
      dialog: false,
      selectedInvoiceId: null,
    }
  },
  computed: {
    ...mapBuyerGetters(['selectedBuyer']),
    ...mapGlobalGetters(['selectedBrand']),
    invoiceList () {
      // Add group by days also
      // { header: 'Today' }
      if (this.invoices) {
        let inv = this.invoices.filter((item) => {
          // return item['buyerId'] === this.selectedBuyer && item['brand'] === this.selectedBrand && (item['status'] === 'due' || item['status'] === 'partial') 
          return item['buyerId'] === this.selectedBuyer &&
          (item.deleted != true) && item['brand'] === this.selectedBrand && (item['status'] === 'due' || item['status'] === 'partial') 
        })
        return inv.map(item => {
          let localDate = new Date(item['date'])
          item['date'] = localDate.toDateString()
          return item
        })
      }
      return []
    }
  },
  methods: {
    openInvoice (selectedInvoiceId) {
      this.selectedInvoiceId = selectedInvoiceId
      this.dialog = true
    },
    updateInvoice () {
      console.log('Update Invoice Called')
    },
    openClosedTransactions() {
      this.$parent.$emit('buyer.statements.view');
    }
  },  
  destroyed () {
    // this.$unbind('invoices')
  }
}
</script>
<style scoped>
  .avatar {
    background: #8d8d8d;
    color: white
  }
</style>

<style>
.due-inv-list .v-list__tile.v-list__tile--avatar.theme--light {
    height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/Buyers/Buyer/BuyerInvoices.vue